import React from "react";
import settings from "../settings";
import {
  LPPOLICE,
  ENTERSECT,
  LPPOLICE_TITLE,
  ENTERSECT_TITLE,
  LOCATEPLUS_TITLE,
} from "../components/pages/Const";
import logo from "../images/locate-plus-logo.png";
import lppolicelogo from "../images/LPPoliceLogo.png";
import entersectlogo from "../images/entersect_logo.png";
import Footer from "../components/navigation/Footer";
import FooterLpPolice from "../components/navigation/FooterLpPolice";
import FooterEntersect from "../components/navigation/FooterEntersect";
import locateplusIcon from "../images/locateplus.ico";
import lppoliceIcon from "../images/lppolice.ico";
import entersectIcon from "../images/entersect.ico";
import {
  getLocateplusBrand,
  getLpPoliceBrand,
  getEntersectBrand,
} from "../components/navigation/Brand";

export const getAppLogo = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return lppolicelogo;
    case ENTERSECT:
      return entersectlogo;
    default:
      return logo;
  }
};

export const getAppTitle = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return LPPOLICE_TITLE;
    case ENTERSECT:
      return ENTERSECT_TITLE;
    default:
      return LOCATEPLUS_TITLE;
  }
};

export const getAppIcon = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return lppoliceIcon;
    case ENTERSECT:
      return entersectIcon;
    default:
      return locateplusIcon;
  }
};

export const getAppFooter = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return <FooterLpPolice />;
    case ENTERSECT:
      return <FooterEntersect />;
    default:
      return <Footer />;
  }
};

export const getAppBrand = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return getLpPoliceBrand();
    case ENTERSECT:
      return getEntersectBrand();
    default:
      return getLocateplusBrand();
  }
};

export const updatePageHeaders = () => {
  document.title = getAppTitle();
  const favicon = document.getElementById("favicon");
  favicon.href = getAppIcon();
};

export const getTermsOfUseLink = () => {
  switch (settings.appName) {
    case LPPOLICE:
      return "https://lppolice.com/wp-content/uploads/LP-Police-Terms-of-Use.pdf";
    case ENTERSECT:
      return "https://entersect.net/wp-content/uploads/2026/07/Entersect-Terms-of-Use.pdf";
    default:
      return "https://locateplus.com/wp-content/uploads/2026/07/LocatePLUS-Terms-of-Use.pdf";
  }
}

export const hideCaseManagement = (reports, reportId) =>  
    reports.includes(reportId);



// WEBPACK FOOTER //
// ./src/utils/PageHelper.js